module.exports = __webpack_public_path__ + "img/logo_img.5193f6a8.jpg";